import { render, staticRenderFns } from "./PrazoPagamento.vue?vue&type=template&id=50d3e15a&scoped=true"
import script from "./PrazoPagamento.vue?vue&type=script&lang=js"
export * from "./PrazoPagamento.vue?vue&type=script&lang=js"
import style0 from "./PrazoPagamento.vue?vue&type=style&index=0&id=50d3e15a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d3e15a",
  null
  
)

export default component.exports